import React, { useState } from 'react';
import Data from '../../../Json_Files/Terms_And_Condition_Page.json';
import { motion } from 'framer-motion';

const termsData = {
  hero: {
    title: "Terms & Conditions",
    description:
      "Please Read These Terms And Conditions Carefully Before Placing An Order."
  },
  sections: [
    {
      id: 1,
      title: "International Sample Policy",
      color: "#16a34a",
      points: [
        "A Payment of $80 Is Required In Advance For Sample.",
        "The Sample Payment Is Non-refundable , Unless It Is Applied To A Final Order.",
        "The Sample Payment Will Be Deducted From The Final Invoice For Orders Placed Within 60 Days Of Sample Delivery.",
        "Our Preferred Payment Method For Sample Is Via Paypal.",
        "Samples Will Be Shipped By Air Only And May Take 7–12 Business Days To Arrive, Depending On Your Location And Connectivity.",
        "If Customs Duties, Taxes, Or Import Fees Associated With The Sample Shipment Are The Responsibility Of The Buyer.",
        "Samples Are Processed And Dispatched Within 2–3 Business Days After Payment Confirmation.",
        "Tracking Details Will Be Provided Via Email Once The Shipment Is Dispatched.",
        "For Any Questions Or Assistance, Please Contact Us."
      ]
    },
    {
      id: 3,
      title: "Payment Terms",
      color: "#7c3aed",
      points: [
        "We Accept Payments Via PayPal , Bank Transfer (T/T) , Credit Card , And Letter Of Credit (LC)",
        "For Orders $50,000 And Above , 50% Advance Payment Is Required, And The Remaining 50% Must Be Paid Via At Sight LC (Letter Of Credit) Upon Shipment.",
        "For Orders Between $15,000 And $49,999 , 40% Advance Payment Is Required, And The Remaining 60% Must Be Paid Via At Sight LC (Letter Of Credit) Upon Shipment.",
        "For Orders Below $14,999 , 100% Advance Payment Is Required, Or 100% Payment Must Be Made Via At Sight LC (Letter Of Credit) Before Shipment.",
        "For OEM Orders (White Labeling) , 100% Advance Payment Is Mandatory Before Production Begins, Regardless Of Order Value.",
        "All Payments Must Be Made In USD (United States Dollars $) Unless Otherwise Agreed In Writing.",
        "Bank Charges, Transaction Fees, Or Letter Of Credit (LC) Issuance Fees Are The Responsibility Of The Buyer.",
        "Orders Will Only Be Processed After Receipt Of Cleared Payment Or Confirmation Of Payment.",
        "Customized Payment Terms May Be Negotiated For Large Orders On A Case-By-Case Basis.",
        "For Any Questions Or Assistance, Please Contact Us."
      ]
    },
    {
      id: 4,
      title: "Shipping Terms",
      color: "#facc15",
      points: [
        "All Export Shipments Are Governed By Incoterms® 2020 , With FOB (Free On Board) Mundra As The Standard Term Unless Otherwise Agreed In Writing.",
        "Alternative Shipping Terms (Ex-Works, FAS, FOB, CFR, CNF, CIF, CPT, CIP) May Be Negotiated And Specified In The Sales Contract.",
        "Shipping Will Only Be Possible After Payment Or Payment Confirmation Is Received.",
        "Orders Are Typically Dispatched Within 5–7 Business Days Of Payment Confirmation, Subject To Product Availability And Production Schedules.",
        "Transit Times Vary Based On Destination And Shipping Method.",
        "Estimated Delivery Dates Will Be Communicated Upon Shipment.",
        "Buyers May Specify A Preferred Carrier, Subject To Approval And Additional Costs.",
        "Export Documentation, Including Commercial Invoice, Packing List, Certificate Of Origin, And Bill Of Lading , Will Be Provided Upon Shipment.",
        "Buyers Are Responsible For Import Customs Clearance, Duties, And Taxes At The Destination.",
        "Risk Of Loss Or Damage Transfers To The Buyer As Per The Agreed Incoterms",
        "Airoxin International Is Not Liable For Delays Caused By Customs, Force Majeure, Or Carrier Issues Beyond Our Control.",
        "In The Event That Goods Are Damaged Or Other Issues Occur During Transport, Insurance Claims Are The Responsibility Of The Buyer In Their Country. However, We Will Provide Assistance To Facilitate The Process.",
        "The Risk Of Damage Or Loss During Transport Depends On The Agreed Incoterms® 2020 , As Specified In The Sales Contract.",
        "Shipping By Air Typically Takes 7–15 Days , Depending On Destination And Location.",
        "Shipping By Sea Typically Takes 30–60 Days , Depending On Destination And Location.",
        "For Any Questions Or Assistance, Please Contact Us."
      ]
    },
    {
      id: 2,
      title: "Minimum Order Quantity (MOQ)",
      color: "#2563eb",
      points: [
        "No MOQ Is Required For Orders Without White Labeling (NON-OEM).",
        "A Minimum Order Quantity (MOQ) Of 120 Boxes Is Required For Each Product With White Labeling (OEM)."
      ]
    },
    {
      id: 5,
      title: "Our Recommendations",
      color: "#F26B0F",
      points: [
        "We Highly Suggest Checking A Sample Before Proceeding With Your Bulk Order To Ensure Product Satisfaction.",
        "Before Placing An Order, Please Review Your Country’s Rules And Regulations Or Consult With Your Freight Forwarder And Customs Clearance Agency To Ensure All Necessary Documents Are Prepared For Smooth Customs Clearance.",
        "To Maximize Price Benefits, We Recommend Ordering A Minimum 20ft Container With Assorted Products.",
        "Opting For A Full Container Load (FCL) Provides Greater Cost Savings Compared To Smaller Shipments.",
        "For Significant Price Benefits, Consider Sea Transportation, As It Is More Economical Than Air Freight.",
        
      ]
    }
  ]
};

const TermsAndConditions_Section = () => {

let [Conditions, SetConditions] = useState(Data);
return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="min-h-screen bg-gray-900 text-white"
    >
      {/* Hero Section */}
      <motion.section
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="pt-20 bg-gray-900"
      >
        <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
          
          <motion.h2
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="text-center text-4xl sm:text-5xl font-bold text-white mb-6 relative"
        >
         {Data.Hero.Title}
          <span className="block mt-4 h-1 bg-gradient-to-r from-green-500 to-blue-500 w-40 mx-auto rounded-full" />
        </motion.h2>
          <p className="text-lg sm:text-xl text-gray-400 leading-relaxed">
            {Data.Hero.Description}
          </p>
        </div>
      </motion.section>

      {/* Card Sections */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {Data.Sections.map((section) => (
            <motion.div
              key={section.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="rounded-3xl p-6 sm:p-8 backdrop-blur-lg shadow-lg"
              style={{ backgroundColor: `${section.Color}20` }}
              whileHover={{ scale: 1.02 }}
            >
              <h2
                className="text-3xl font-semibold mb-4"
                style={{ color: section.Color }}
              >
                {section.Title}
              </h2>
              {/* <p className="text-gray-400 mb-4">{section.content}</p> */}
              <ul className="list-disc list-inside text-gray-400 space-y-2">
                {section.Points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </section>
    </motion.div>
  );
};

export default TermsAndConditions_Section;